.actions {
  color: #757575;
  align-self: flex-end;
}
